import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import cls from 'classnames';

import Button from '@ott/button';
import FirstErrorShower from '@ott/first-error-shower';
import ReverseIcon from '@ott/icon-reverse';
import { l10n } from '@ott/l10n';
import { withLayoutContext } from '@ott/layout-context';
import Tooltip from '@ott/tooltip';

import { focusField } from '../../utility/focusField';

import styles from './SearchForm.scss';

@withLayoutContext
class SearchForm extends PureComponent {
  static propTypes = {
    fields: PropTypes.shape({
      from: PropTypes.element,
      to: PropTypes.element,
      dates: PropTypes.element,
      travellers: PropTypes.element,
    }).isRequired,
    onSubmit: PropTypes.func.isRequired,
    onSwapDirectionsClick: PropTypes.func.isRequired,
    errors: PropTypes.objectOf(PropTypes.oneOfType(PropTypes.object)),
    showErrors: PropTypes.bool,
    customButtonText: PropTypes.string,
  };

  static defaultProps = {};

  constructor(props, ctx) {
    super(props, ctx);

    this.state = {
      submitTime: null,
    };
  }

  componentDidMount() {
    // включить обратно на новом geo-autocomplete
    // SearchForm.focusOnFirstEmptyField(this.props.initialValues);
  }

  static focusOnFirstEmptyField(formValues) {
    const { from, to, dates } = formValues;

    const names = ['fromText', 'toText', 'dates'];
    const values = [from.name, to.name, dates && dates.startDate];

    const firstEmptyValueIndex = values.findIndex((value) => !value);
    if (firstEmptyValueIndex !== -1) {
      focusField(names[firstEmptyValueIndex]);
    }
  }

  handleFormSubmit = (event) => {
    const { onSubmit } = this.props;

    if (event) {
      event.preventDefault();
    }

    this.setState({
      submitTime: Date.now(),
    });

    onSubmit();
  };

  renderSwapButton() {
    const { onSwapDirectionsClick } = this.props;

    const swapTooltipContent = (
      <div data-locator="reverse-button-tooltip-text">{l10n('flightsSearchForm.reverse')}</div>
    );

    return (
      <Tooltip content={swapTooltipContent} isDisabledOnTouchDevice={true}>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
        <div className={styles.swapButton} onClick={onSwapDirectionsClick}>
          <div className={styles.inner}>
            <ReverseIcon className={styles.icon} tabIndex={-1} />
          </div>
        </div>
      </Tooltip>
    );
  }

  render() {
    const {
      fields,
      fields: { from, to },
      errors: { totalChildren, ...errors },
      showErrors,
      customButtonText,
      formRef,
      submitRef,
      isMobileLayout,
    } = this.props;

    const { submitTime } = this.state;
    const submitFailed = showErrors && Object.keys(errors).length;

    return (
      <form
        ref={formRef}
        id="RailwaysSearchForm"
        onSubmit={this.handleFormSubmit}
        data-locator="search-form"
        className={styles.SearchForm}
        autoComplete="off"
      >
        <FirstErrorShower
          show={submitFailed}
          errors={errors}
          time={submitTime}
          effect="transition"
          container={this}
        />
        <div className={cls(styles.cell, styles.from)}>
          {React.cloneElement(from, {
            ...from.props,
            triggerProps: {
              ...from.props.triggerProps,
              className: styles.from__input,
            },
            overlayProps: {
              ...from.props.overlayProps,
              className: styles.autocomplete__overlay,
            },
          })}
        </div>
        {!isMobileLayout && this.renderSwapButton()}
        <div className={cls(styles.cell, styles.to)}>
          {React.cloneElement(to, {
            ...to.props,
            triggerProps: {
              ...to.props.triggerProps,
              className: styles.to__input,
            },
            overlayProps: {
              ...to.props.overlayProps,
              className: styles.autocomplete__overlay,
            },
          })}
        </div>
        {isMobileLayout && this.renderSwapButton()}
        <div className={cls(styles.cell, styles.datepicker)}>
          {React.cloneElement(fields.dates, {
            childrenClassNames: {
              input: styles.datepicker__input,
              calendar: styles.datepicker__calendar,
            },
          })}
        </div>
        <div className={cls(styles.cell, styles.travellers)}>
          {React.cloneElement(fields.travellers, {
            childrenClassNames: { input: styles.travellers__input },
          })}
        </div>

        <div className={styles.submitButtonWrapper}>
          <Button innerRef={submitRef} type="submit" className={styles.submitButton}>
            {customButtonText || 'Найти'}
          </Button>
        </div>
      </form>
    );
  }
}

export default SearchForm;
